// CertifyPage — Phase 3 of the Build flow (frontend redesign v0.2 §4).
//
// Merges the former Attest + Verify steps into a single fail-closed
// boundary. The four-state certificate is the headline: you read where
// the Collection stands (VerificationPage — certificate summary + the
// per-condition table), then you act to move conditions off CONTRADICTED
// / UNTESTABLE by supplying warrants (AttestPage — the per-condition
// attestation forms).
//
// This is a compositional merge for R2: it stacks the two existing,
// independently-loading surfaces under one route + one mental model. A
// follow-on slice can fuse them into a single interleaved
// condition-by-condition view (warrant control inline on each row).

import { AttestPage } from "./AttestPage";
import { useSession } from "./SessionContext";
import { VerificationPage } from "./VerificationPage";

export function CertifyPage() {
  const { session } = useSession();

  if (session === null) {
    return (
      <section>
        <h1>Certify</h1>
        <p style={{ color: "#888" }}>
          Create a session on the <em>Session</em> step first. Certify is the
          single fail-closed boundary — it reads the four-state certificate
          and routes any contradicted / untestable condition to a human.
        </p>
      </section>
    );
  }

  return (
    <div>
      <div style={introStyle}>
        <h1 style={{ margin: "0 0 0.35rem 0" }}>Certify</h1>
        <p style={{ margin: 0, color: "#555", fontSize: "0.9rem" }}>
          The single fail-closed boundary. The certificate below is the source
          of truth — <strong>CONTRADICTED</strong> blocks by default and
          <strong> UNTESTABLE</strong> is never certified as absent. Supply
          warrants in the attestation forms to move conditions off those
          states; A/AA/AAA is only a derived view of what you see here.
        </p>
      </div>

      {/* Read: certificate summary + per-condition four-state table. */}
      <VerificationPage />

      <hr style={dividerStyle} />

      {/* Act: per-condition data-attestation forms. */}
      <AttestPage />
    </div>
  );
}

const introStyle: React.CSSProperties = {
  marginBottom: "1.25rem",
  paddingBottom: "0.75rem",
  borderBottom: "1px solid #eee",
};

const dividerStyle: React.CSSProperties = {
  margin: "2rem 0",
  border: "none",
  borderTop: "1px dashed #ddd",
};
